import {photoBoxReducer} from './slices/photoBox/photoBox.slice';
import {sessionReducer} from './slices/session/session.slice';
import {paymentsReducer} from './slices/payments/payments.slice';
import {bookExperienceReducer} from './slices/bookExperience';

const rootReducer = {
  photoBox: photoBoxReducer,
  session: sessionReducer,
  payments: paymentsReducer,
  bookExperience: bookExperienceReducer,
};

export default rootReducer;
